module.exports = __webpack_public_path__ + "static/media/policy-step-icon-fc.1f07a3a0.svg";